import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/viewpaybill.png'


const _withScopeId = n => (_pushScopeId("data-v-50df0388"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-6" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "View & Pay your bill"),
  /*#__PURE__*/_createElementVNode("div", { class: "subtitle-1 mt-n1" }, "Let's get your Bill payment done!")
], -1))
const _hoisted_2 = {
  target: "_blank",
  href: "https://login.jtel.in/customer_portal"
}
const _hoisted_3 = {
  target: "_blank",
  href: "https://login.jtel.in/customer_portal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_v_row, { class: "mt-3 mx-2 mx-md-8" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "d-flex justify-center image-holder" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: _imports_0,
              height: "100%"
            }),
            _createElementVNode("a", _hoisted_2, [
              _createVNode(_component_v_btn, { class: "btn-primary on-image recharge" }, {
                default: _withCtx(() => [
                  _createTextVNode("Recharge")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("a", _hoisted_3, [
              _createVNode(_component_v_btn, { class: "btn-primary on-image paybills" }, {
                default: _withCtx(() => [
                  _createTextVNode("Pay Bills")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}